import { connect, useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import styles from './SearchKnmPanelFilters.module.scss';
import { knmSearchFilterTitleMapper } from '../common/knmSearchFilterTitleMapper';
import { KnmSearchInitFilterKeys } from '../types/KnmSearchInitFilterKeys';
import { getKnmSearchFilter } from '../selectors/knmSearchSelectors';
import { knmSearchGetData, knmSearchSetFilter } from '../actions/knmSearchActions';
import { IKnmSearchInitFilter } from '../interfaces/IKnmSearchInitFilter';

interface IKnmSearchFilterArrayProps {
  filterName: KnmSearchInitFilterKeys;
  filterValue: ISelectOption[];
  filter: Partial<IKnmSearchInitFilter>;
}

const KnmSearchFilterArrayWithoutStore = ({ filterName, filterValue, filter }: IKnmSearchFilterArrayProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const handleClickFilterArray = (id: string | number) => () => {
    dispatch(
      knmSearchSetFilter({
        ...filter,
        [filterName]: filterValue.filter(x => {
          return x.id !== id;
        }),
      }),
    );
    dispatch(knmSearchGetData());
  };

  return (
    <div className={styles.FilterWrap}>
      {filterValue.length !== 0 && <div className={styles.FilterLabel}>{knmSearchFilterTitleMapper(filterName)}</div>}
      {filterValue.map(e => (
        <div key={e.id} className={styles.FilterTextWrap}>
          <div className={styles.FilterText}>{e.label}</div>
          <div className={styles.FilterRemove} onClick={handleClickFilterArray(e.id)} />
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  filter: getKnmSearchFilter(state),
});

export const KnmSearchFilterArray = connect(mapStateToProps)(KnmSearchFilterArrayWithoutStore);
